import { registerSW } from 'virtual:pwa-register'

let updateServiceWorker = null

const registerServiceWorker = () => {
  if (updateServiceWorker) return

  updateServiceWorker = registerSW({
    immediate: true,
    onNeedRefresh() {
      window.dispatchEvent(new CustomEvent('v4lUpdateAvailable'))
    },
    onRegisteredSW(_serviceWorkerUrl, registration) {
      if (!registration || !navigator.onLine) return

      registration.update().catch((error) => {
        console.error('Service worker update check failed:', error)
      })
    },
    onRegisterError(error) {
      console.error('Service worker registration failed:', error)
    }
  })
}

const applyServiceWorkerUpdate = async () => {
  if (!updateServiceWorker) return
  await updateServiceWorker(true)
}

export { applyServiceWorkerUpdate, registerServiceWorker }
